import React from 'react';
import { Modal } from 'react-bootstrap';
import { faXmark, faWarning, faExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./ModalStyle.css";
import { ButtonBlue, ButtonLightGrey } from '../HouseStyle/Components/Buttons';

const ResetDemoModal = ({
  showModal,
  setShowModal,
  onConfirmReset,
  isLoading = false
}) => {
  return (
    <Modal show={showModal} onHide={() => setShowModal(false)} centered size="xl">
      <Modal.Header className="modalTop d-flex justify-content-between">
        <Modal.Title className="ms-3 BlockTitle">Reset Demo Omgeving</Modal.Title>
        <button
          className="border-0 bg-transparent"
          variant="transparent"
          onClick={() => setShowModal(false)}
        >
          <FontAwesomeIcon icon={faXmark} className="closeModal" />
        </button>
      </Modal.Header>
      <Modal.Body className="modalCenter pb-0">
        <div className="ms-3">
          <p>Weet u zeker dat u de demo omgeving wilt resetten?</p>
          <div className="alert alert-warning mt-3">
            <FontAwesomeIcon icon={faWarning} className="me-2" />
            <span>Dit zal alle demo data verwijderen en terugzetten naar de oorspronkelijke staat. Deze actie kan niet ongedaan worden gemaakt.</span>
          </div>
          <div className="alert alert-danger mt-3">
            <FontAwesomeIcon icon={faExclamation} className="me-2" />
            <span>LET OP! Dit kan enkele minuten duren.</span>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="modalBottom">
        <div className="d-flex flex-row">
          <div className="me-3">
            <ButtonLightGrey 
              text="Annuleren" 
              className="ms-3 btn bg-danger text-white" 
              onClickFunction={() => setShowModal(false)}
              disabled={isLoading}
            />
          </div>
          <ButtonBlue
            text={isLoading ? "Bezig met resetten..." : "Reset bevestigen"}
            onClickFunction={onConfirmReset}
            disabled={isLoading}
          />
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default ResetDemoModal;